export const SET_PLAYING = 'MEDIA_PLAYER/SET_PLAYING'
export const SET_PLAY_COMPLETED = 'MEDIA_PLAYER/SET_PLAY_COMPLETED'
export const SET_PAUSE_TIMELINE = 'MEDIA_PLAYER/SET_PAUSE_TIMELINE'
export const PAUSE = 'MEDIA_PLAYER/PAUSE'
export const CHANGE_ASPECT_RATIO = 'MEDIA_PLAYER/CHANGE_ASPECT_RATIO'
export const SET_LOADING = 'MEDIA_PLAYER/SET_LOADING'
